import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CallState } from '@lcs/shared/api';
import { AddScheduleData } from '../models/add-schedule-data';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-add-schedule-view',
    templateUrl: './add-schedule-view.component.html',
    standalone: false
})
export class AddScheduleViewComponent {
   @Input() callState: CallState;

   @Output() formSubmitted = new EventEmitter<AddScheduleData>();

   @Output() formCanceled = new EventEmitter<void>();

   @Input() form: UntypedFormGroup;

   onCloseClick(): void {
      this.formCanceled.emit();
   }

   onCreate(): void {
      if (this.form.valid) {
         this.formSubmitted.emit();
      }
   }
}
